import React from 'react';
import { NavItemDef } from '../navItems';
import { getLmsUrl } from 'data_sources/constants';

export const REPORTING_NAV_ITEMS: NavItemDef[] = [
  // Analytics section
  {
    key: 'reporting.divider.analytics',
    label: 'reporting.navItems.dividers.analytics',
    divider: true,
    visibility: ({ hasPermission, isFeatureEnabled, currentOrganizationId }) => {
      const hasTrainingAccess = hasPermission('accessTrainingInsightsCenter', currentOrganizationId);
      const hasPolicyAccess = hasPermission('accessPolicyInsightsCenter', currentOrganizationId);
      const policyFlagEnabled = isFeatureEnabled('policy_insights_center');
      return hasTrainingAccess || (hasPolicyAccess && policyFlagEnabled);
    },
  },
  {
    key: 'reporting.insightsCenter',
    label: 'reporting.navItems.insightsCenter',
    subtitle: 'reporting.navItems.subtitles.insightsCenter',
    path: 'insights-center',
    visibility: ({ hasPermission, isFeatureEnabled, currentOrganizationId }) => {
      const hasTrainingAccess = hasPermission('accessTrainingInsightsCenter', currentOrganizationId);
      const hasPolicyAccess = hasPermission('accessPolicyInsightsCenter', currentOrganizationId);
      const policyFlagEnabled = isFeatureEnabled('policy_insights_center');
      return hasTrainingAccess || (hasPolicyAccess && policyFlagEnabled);
    },
  },
  // Run Reports section
  {
    key: 'reporting.divider.runReports',
    label: 'reporting.navItems.dividers.runReports',
    divider: true,
    visibility: ({ hasPermission, isFeatureEnabled, currentOrganizationId }) =>
      hasPermission('reportUserList', currentOrganizationId) ||
      hasPermission('listPolicyAcknowledgementReports', currentOrganizationId) ||
      hasPermission('getDtbReport', currentOrganizationId) ||
      hasPermission('trainingAdminActions', currentOrganizationId) ||
      isFeatureEnabled('performanceReportingManager'),
  },
  {
    key: 'reporting.users',
    label: 'reporting.navItems.users',
    subtitle: 'reporting.navItems.subtitles.users',
    path: 'users',
    permissions: ['reportUserList'],
  },
  {
    key: 'reporting.policyAcknowledgements',
    label: 'reporting.navItems.policyAcknowledgements',
    subtitle: 'reporting.navItems.subtitles.policyAcknowledgements',
    path: 'policy-acknowledgments',
    permissions: ['listPolicyAcknowledgementReports'],
  },
  {
    key: 'reporting.dtbs',
    label: 'reporting.navItems.dailyTrainingBulletins',
    subtitle: 'reporting.navItems.subtitles.dailyTrainingBulletins',
    path: 'dtbs',
    permissions: ['getDtbReport'],
  },
  {
    key: 'reporting.trainingReports',
    label: 'reporting.navItems.trainingReports',
    href: getLmsUrl('/analytics/reports/'),
    permissions: ['trainingAdminActions'],
    featurePermission: 'training',
  },
  {
    key: 'reporting.performanceReportingData',
    label: 'reporting.navItems.performanceReportingData',
    subtitle: 'reporting.navItems.subtitles.performanceReportingData',
    path: 'report-data',
    permissions: ['viewFieldBank'],
    visibility: ({ isFeatureEnabled, currentOrganizationId }) =>
      isFeatureEnabled('performanceReportingManager') &&
      currentOrganizationId !== 'lexipoladminstaffuuid',
  },
];
